/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

import { cloneDeep } from 'lodash';
import { EVENTS } from '../../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../../app/common/components/forms/select-picker/select-picker-types.enum';
import { connectionIconUrlByType } from '../../../../../app/common/helper/connection-icon-url-by-type.helper';
import { updateComponent } from '../../../../../app/package-designer/store/component.actions';

xplenty.directive('restApiAuthentication', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./rest-api-authentication.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$rootScope',
        'connectionsService',
        'selectPickerModal',
        'ngrxStoreService',
        function ($scope, $rootScope, connectionsService, selectPickerModal, ngrxStoreService) {
          $scope.hasComponentChanged = 0;

          $scope.componentUpdate = function (component) {
            $scope.component.dynamic_connection = component.dynamic_connection;
          };

          $scope.authenticationStep.valid = true;
          $scope.connectionQuery = {
            type: $scope.component.connectionTypes,
          };
          $scope.connectionTypes = $scope.component.connectionTypes.split(',');
          selectPickerModal.setConnectionTypes($scope.connectionTypes.join());

          $scope.onCreateNewConnection = ({ connection, type }) => {
            selectPickerModal.createNew(connection, type, 'connection-picker-rest-api-editor');

            const subscriber = $rootScope.$on(EVENTS.CONNECTION_CREATED, (event, connectionItem) => {
              ngrxStoreService.dispatch(
                loadSelectPickerItems({
                  id: 'connection-picker-rest-api-editor',
                  itemType: type,
                  params: { ...queryParamsMap[type], ...$scope.connectionQuery },
                }),
              );
              $scope.selectConnection(connectionItem);
              subscriber();
            });
          };

          const setTag = function (name) {
            $scope.authenticationStep.tags = [
              {
                icon: '',
                name,
              },
            ];
          };

          const setConnectionTag = function (connection) {
            if (!connection) {
              $scope.authenticationStep.tags = [];
              $scope.authenticationStep.valid = false;
              return;
            }
            const img = `<img class="tag-icon" src="${connectionIconUrlByType(connection.type)}" alt="${
              connection.name
            }" />`;
            setTag(`${img}<b>${_.escape(connection.name)}</b>`);
            $scope.authenticationStep.valid = true;
          };

          $scope.selectConnection = (connection) => {
            $scope.component.connection = connection;
            $scope.authenticationStep.valid = true;
            setConnectionTag(connection);
          };

          let $watcher;

          const watch = function () {
            $watcher = $scope.$on('connection-selected', function (event, connection) {
              setConnectionTag(connection);
            });
          };

          $scope.$watch(
            'component',
            function (component, oldComponent) {
              if (component && component.name !== oldComponent.name) {
                $scope.hasComponentChanged += 1;
              }
              if (component.authentication === 'basic') {
                $scope.authenticationStep.valid =
                  (component.username && component.username.length) ||
                  (component.password && component.password.length);
              }
              $scope.schemaImporterStep.validate();
            },
            true,
          );

          $scope.$watch('component.connection', function (newConnection, oldConnection) {
            if (newConnection.id !== oldConnection.id) {
              $scope.hasComponentChanged += 1;
            }
          });

          $scope.setAuthenticationType = (authenticationType) => {
            $scope.component.authentication = authenticationType;
            if (authenticationType !== 'connection') {
              $scope.component.connection = {};
            }
            if (authenticationType !== 'basic') {
              $scope.component.username = null;
              $scope.component.password = null;
            }
            ngrxStoreService.dispatch(updateComponent({ component: cloneDeep($scope.component) }));
          };

          $scope.$watch('component.authentication', function (authentication) {
            if ($watcher) $watcher();

            if (authentication === 'basic') {
              setTag('<b>Basic</b>');
              $scope.component.connection = {};
            } else if (authentication === 'none') {
              $scope.authenticationStep.valid = true;
              $scope.component.connection = {};
              setTag('<b>None</b>');
            } else if (authentication === 'connection') {
              setConnectionTag($scope.component.connection);
              watch();
            }
          });
        },
      ],
    };
  },
]);
